import { cn } from "@reactive-resume/utils";
import { useId } from "react";

type Props = {
  size?: number;
  className?: string;
  title?: string;
};

export const BrandMark = ({ size = 32, className, title }: Props) => {
  const titleId = useId().split(":").join("");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-hidden={title ? undefined : true}
      aria-labelledby={title ? titleId : undefined}
      className={cn("shrink-0", className)}
    >
      {title ? <title id={titleId}>{title}</title> : null}

      <rect width="64" height="64" rx="14" fill="#4F46E5" />
      <rect x="14" y="38" width="7" height="12" rx="1.5" fill="white" fillOpacity="0.55" />
      <rect x="24" y="30" width="7" height="20" rx="1.5" fill="white" fillOpacity="0.80" />
      <path d="M34 22 L41 22 L48 15 L48 50 L34 50 Z" fill="white" />
    </svg>
  );
};
